import MarketingLink from './MarketinLink';

export default MarketingLink;
